import { required, optional } from 'AppReact/schema';

export default {
    id: required('string'),
    status: required('string'),
    name: required('string'),
    dob: optional('jsDate'),
    email: required('string'),
    ssn: required('string'),
    homePhone: required('string'),
    workPhone: required('string'),
    cellPhone: required('string'),

    hasError: optional('boolean'),
    statusError: optional('string'),
    nameError: optional('string'),
    dobError: optional('string'),
    emailError: optional('string'),
    ssnError: optional('string'),
    homePhoneError: optional('string'),
    workPhoneError: optional('string'),
    cellPhoneError: optional('string'),
}


export const defaultOccupant = {
    id: 'leaseholder',
    status: 'leaseholder',
    name: '',
    dob: null,
    email: '',
    ssn: '',
    homePhone: '',
    workPhone: '',
    cellPhone: '',

    hasError: false,
    statusError: '',
    nameError: '',
    dobError: '',
    emailError: '',
    ssnError: '',
    homePhoneError: '',
    workPhoneError: '',
    cellPhoneError: '',
}
